import React, { useState, useEffect } from 'react';
import { db, collection, addDoc, getDocs, query, where, doc, getDoc } from '../../firebase';
import { useNavigate } from 'react-router-dom';

const eloCategories = {
  P50: 600,
  P100: 700,
  P150: 800,
  P200: 900,
  P300: 1200,
  P400: 1600,
  P500: 2000,
};

const AddTeamAdmin = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    teamName: '',
    email: '',
    newsletter: false,
    consentInfo: false,

    joueur1: {
      nom: '',
      prenom: '',
      phone: '',
      elo: '',
      isLocked: false
    },
    joueur2: {
      nom: '',
      prenom: '',
      phone: '',
      elo: '',
      isLocked: false
    }
  });

  const [tournamentId, setTournamentId] = useState('');
  const [tournaments, setTournaments] = useState([]);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const fetchTournaments = async () => {
      try {
        const tournamentsCollection = collection(db, 'tournament_registrations');
        const tournamentsSnapshot = await getDocs(tournamentsCollection);
        const tournamentsList = tournamentsSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setTournaments(tournamentsList);
      } catch (err) {
        console.error("Erreur lors de la récupération des tournois:", err);
      }
    };
  
    fetchTournaments();
  }, []);
  

  const isValidPhone = (phone) => {
    const regex = /^04\d{8}$/; // Commence par 04 et suivi de 8 chiffres
    return regex.test(phone.trim());
  };

  useEffect(() => {
    const checkPlayer = async (phone, joueurKey) => {
      if (!isValidPhone(phone)) return;

      try {
        const res = await fetch(`https://us-central1-mendyx-adafe.cloudfunctions.net/getJoueurByPhone?phone=${phone}`);
        const data = await res.json();

        if (data) {
          setFormData((prev) => ({
            ...prev,
            [joueurKey]: {
              ...prev[joueurKey],
              nom: data.nom,
              prenom: data.prenom,
              elo: data.elo,
              isLocked: true,
            },
          }));
        } else {
          setFormData((prev) => ({
            ...prev,
            [joueurKey]: {
              ...prev[joueurKey],
              elo: '700',
              isLocked: false,
            },
          }));
        }
      } catch (err) {
        console.error(`Erreur joueur${joueurKey === 'joueur1' ? '1' : '2'}:`, err);
      }
    };

    if (formData.joueur1.phone) {
      checkPlayer(formData.joueur1.phone, 'joueur1');
    }
    if (formData.joueur2.phone) {
      checkPlayer(formData.joueur2.phone, 'joueur2');
    }
  }, [formData.joueur1.phone, formData.joueur2.phone]);

  const handleChange = (e, key, subkey = null) => {
    const { name, value, type, checked } = e.target;
    const val = type === 'checkbox' ? checked : value;

    if (key && subkey) {
      setFormData((prev) => {
        const updated = {
          ...prev,
          [key]: {
            ...prev[key],
            [subkey]: val,
          },
        };

        if (subkey === 'phone' && !/^(?:\+32|0)4\d{8}$/.test(val.trim())) {
          updated[key].isLocked = false;
        }

        return updated;
      });
    } else {
      setFormData((prev) => ({ ...prev, [name]: val }));
    }
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  if (!formData.newsletter) {
    alert("Veuillez accepter de recevoir la newsletter.");
    return;
  }

  if (!isValidPhone(formData.joueur1.phone) || !isValidPhone(formData.joueur2.phone)) {
    alert("Veuillez entrer des numéros de téléphone belges valides commencant par 04 (047....).");
    return;
  }

  if (formData.joueur1.phone.trim() === formData.joueur2.phone.trim()) {
    alert("⛔ Les deux joueurs ne peuvent pas avoir le même numéro de téléphone.");
    return;
  }

  const nom1 = formData.joueur1.nom.trim().toLowerCase();
  const prenom1 = formData.joueur1.prenom.trim().toLowerCase();
  const nom2 = formData.joueur2.nom.trim().toLowerCase();
  const prenom2 = formData.joueur2.prenom.trim().toLowerCase();

  if (nom1 === nom2 && prenom1 === prenom2) {
    alert("⛔ Les deux joueurs ne peuvent pas avoir le même nom et prénom, même avec des numéros différents.");
    return;
  }

  const tournamentDocRef = doc(db, 'tournament_registrations', tournamentId);
  const registrationsRef = collection(tournamentDocRef, 'inscriptions');

  try {
    const duplicateTeamQuery = query(
      registrationsRef,
      where('teamName', '==', formData.teamName.trim())
    );
    const duplicateEmailQuery = query(
      registrationsRef,
      where('email', '==', formData.email.trim())
    );

    const duplicateTeamSnapshot = await getDocs(duplicateTeamQuery);
    const duplicateEmailSnapshot = await getDocs(duplicateEmailQuery);

    if (!duplicateTeamSnapshot.empty || !duplicateEmailSnapshot.empty) {
      alert("L'équipe ou l'adresse e-mail est déjà enregistrée pour ce tournoi.");
      return;
    }

    await addDoc(registrationsRef, {
      tournamentId,
      teamName: formData.teamName,
      email: formData.email,
      joueur1: {
        ...formData.joueur1,
        elo: String(formData.joueur1.elo) // Convertir l'ELO en chaîne de caractères
      },
      joueur2: {
        ...formData.joueur2,
        elo: String(formData.joueur2.elo) // Convertir l'ELO en chaîne de caractères
      },
      newsletter: formData.newsletter,
      consentInfo: formData.consentInfo, 
      isPaid: true,
      createdAt: new Date(),
    });
    

    console.log('✅ Inscription enregistrée dans la collection "inscriptions"');
    setShowModal(true);
  } catch (error) {
    console.error('Erreur lors de l\'enregistrement de l\'inscription:', error);
    alert('Une erreur s\'est produite. Veuillez réessayer.');
  }
};


  const closeModal = () => {
    setShowModal(false);
    navigate('/admin/dashboard');
  };

  return (
    <section className="container mx-auto my-16 px-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-stretch h-full min-h-[700px]">
        <div className="flex justify-center items-center">
          <div className="relative w-full h-full min-h-[700px] overflow-hidden rounded-lg shadow-lg">
            <img
              src={`/padel${tournamentId}.jpg`}
              alt={`Tournoi de Padel ${tournamentId}`}
              className="object-contain w-full h-full transition-transform duration-300 hover:scale-105"
            />
          </div>
        </div>

        <div className="p-6 bg-white shadow-lg rounded-r-lg transition-transform duration-300 hover:scale-105">
          <h2 className="text-2xl font-semibold text-[#4c2f8e] mb-4">Ajouter une équipe</h2>
          <form className="space-y-4" onSubmit={handleSubmit}>
            <div className="flex flex-col">
              <label htmlFor="teamName" className="text-lg font-medium text-gray-700">
                Nom de l'équipe
              </label>
              <input
                id="teamName"
                name="teamName"
                type="text"
                className="p-2 border rounded-md focus:outline-none focus:ring focus:border-[#4c2f8e]"
                placeholder="Entrez le nom de votre équipe"
                value={formData.teamName}
                onChange={handleChange}
                required
              />
            </div>

            <div className="flex flex-col">
              <label htmlFor="email" className="text-lg font-medium text-gray-700">
                Adresse mail de contact
              </label>
              <input
                id="email"
                name="email"
                type="email"
                className="p-2 border rounded-md focus:outline-none focus:ring focus:border-[#4c2f8e]"
                placeholder="Entrez votre email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="flex flex-col">
              <label htmlFor="tournamentId" className="text-lg font-medium text-gray-700">
                Sélectionnez un tournoi
              </label>
              <select
                id="tournamentId"
                name="tournamentId"
                className="p-2 border rounded-md focus:outline-none focus:ring focus:border-[#4c2f8e]"
                value={tournamentId}
                onChange={(e) => setTournamentId(e.target.value)}
                required
              >
                <option value="">-- Sélectionnez un tournoi --</option>
                {tournaments.map(tournament => (
                  <option key={tournament.id} value={tournament.id}>
                    {tournament.name || `Tournoi ${tournament.id}`}
                  </option>
                ))}
              </select>
            </div>

            {["joueur1", "joueur2"].map((key, index) => (
              <div key={key} className="p-4 border border-gray-300 rounded-md bg-gray-50">
                <h3 className="text-md font-semibold text-[#4c2f8e] mb-2">
                  {index === 0 ? '👤 Joueur 1' : '👤 Joueur 2'}
                </h3>

                <div className="flex flex-col mb-4">
                  <label className="text-sm text-gray-700 flex items-center gap-2 mb-1">
                    Téléphone
                    <div className="flex items-center text-blue-600 text-xs bg-blue-50 px-2 py-1 rounded-full">
                      <span className="mr-1 text-base">ℹ️</span>
                      <span>
                        Format belge requis (047...). Ce champ est essentiel pour le classement.
                      </span>
                    </div>
                  </label>

                  <input
                    type="tel"
                    className="p-2 border border-blue-400 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-300 focus:border-blue-500"
                    placeholder="0470707070"
                    value={formData[key].phone}
                    onChange={(e) => handleChange(e, key, 'phone')}
                    required
                  />

                  <div className="mt-2 text-sm text-gray-600 bg-gray-50 border-l-4 border-blue-400 p-3 rounded-md">
                    🎯 Si ce joueur est déjà inscrit à un tournoi, son nom et classement ELO seront remplis automatiquement.<br />
                    🚀 Sinon, un classement de base devra être sélectionné.
                  </div>
                </div>

                <div className="flex flex-col mb-2">
                  <label className="text-sm text-gray-700">Nom</label>
                  <input
                    type="text"
                    className="p-2 border rounded-md focus:outline-none focus:ring focus:border-[#4c2f8e]"
                    placeholder="Nom"
                    value={formData[key].nom}
                    onChange={(e) => handleChange(e, key, 'nom')}
                    required
                  />
                </div>

                <div className="flex flex-col mb-2">
                  <label className="text-sm text-gray-700">Prénom</label>
                  <input
                    type="text"
                    className="p-2 border rounded-md focus:outline-none focus:ring focus:border-[#4c2f8e]"
                    placeholder="Prénom"
                    value={formData[key].prenom}
                    onChange={(e) => handleChange(e, key, 'prenom')}
                    required
                  />
                </div>

                {formData[key].isLocked ? (
                  <div className="flex flex-col">
                    <label className="text-sm text-gray-700">Classement ELO</label>
                    <input
                      type="number"
                      className="p-2 border rounded-md focus:outline-none focus:ring focus:border-[#4c2f8e]"
                      value={formData[key].elo}
                      disabled
                    />
                  </div>
                ) : (
                  <div className="flex flex-col mb-2">
                    <label className="text-sm text-gray-700">Sélectionner votre niveau estimé</label>
                    <select
                      className="p-2 border rounded-md focus:outline-none focus:ring focus:border-[#4c2f8e]"
                      value={formData[key].elo}
                      onChange={(e) =>
                        handleChange(
                          { target: { value: parseInt(e.target.value), type: 'select-one' } },
                          key,
                          'elo'
                        )
                      }
                      required
                    >
                      <option value="">-- Choisissez une catégorie --</option>
                      {Object.entries(eloCategories).map(([label, value]) => (
                        <option key={label} value={value}>
                          {label} - {value} points
                        </option>
                      ))}
                    </select>
                    <div className="mt-1 text-xs text-gray-500 italic">
                      Ce classement sera utilisé s'il n'existe pas encore pour ce joueur.
                    </div>
                  </div>
                )}
              </div>
            ))}

<div className="flex items-center">                                                                                                                                                                                       
    <input                                                                                                                                                                                                                  
      type="checkbox"                                                                                                                                                                                                       
      id="consentInfo"                                                                                                                                                                                                      
      name="consentInfo"                                                                                                                                                                                                    
      checked={formData.consentInfo}                                                                                                                                                                                        
      onChange={handleChange}                                                                                                                                                                                               
      className="h-4 w-4 text-[#4c2f8e] focus:ring-[#4c2f8e] border-gray-300 rounded"                                                                                                                                       
      required                                                                                                                                                                                                              
    />                                                                                                                                                                                                                      
    <label htmlFor="consentInfo" className="ml-2 text-gray-700">                                                                                                                                                            
      J'accepte que mes informations soient utilisées dans le cadre de mon inscription.                                                                                                                                     
    </label>                                                                                                                                                                                                                
  </div>                                                                                                                                                                                                                    
                                                                                                                                                                                                                            
  <div className="flex items-center">                                                                                                                                                                                       
    <input                                                                                                                                                                                                                  
      type="checkbox"                                                                                                                                                                                                       
      id="newsletter"                                                                                                                                                                                                       
      name="newsletter"                                                                                                                                                                                                     
      checked={formData.newsletter}                                                                                                                                                                                         
      onChange={handleChange}                                                                                                                                                                                               
      className="h-4 w-4 text-[#4c2f8e] focus:ring-[#4c2f8e] border-gray-300 rounded"                                                                                                                                       
    />                                                                                                                                                                                                                      
    <label htmlFor="newsletter" className="ml-2 text-gray-700">                                                                                                                                                             
      J'accepte de recevoir la newsletter.                                                                                                                                                                                  
    </label>                                                                                                                                                                                                                
  </div> 
            <button
              type="submit"
              className="mt-6 w-full px-6 py-3 bg-gradient-to-r from-[#4c2f8e] to-[#ea4c89] text-white rounded-full shadow-lg transform transition-all duration-300 hover:scale-110 hover:shadow-2xl"
            >
              Ajouter l'équipe
            </button>
          </form>
        </div>
      </div>

      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-8 rounded-lg shadow-lg w-11/12 md:w-1/2 lg:w-1/3">
            <h3 className="text-xl font-bold mb-4 text-center">Équipe ajoutée avec succès !</h3>
            <div className="flex flex-col md:flex-row items-center">
              <div className="md:w-1/2">
                <p className="mb-4">
                  <br />
                  L'équipe a été ajoutée avec succès.
                  <br />
                  <br />
                  <strong className="text-center">À vos raquettes, prêts, partez !</strong>
                </p>
              </div>
            </div>
            <button
              onClick={closeModal}
              className="mt-4 w-full px-4 py-2 bg-gradient-to-r from-[#4c2f8e] to-[#ea4c89] text-white rounded-full"
            >
              Fermer
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default AddTeamAdmin;
